import { objAny } from "@/common/common-interface";
import validate from "@/common/regular";
import i18n from "@/config/i18n";
const ruleInline: objAny = {
  oprName: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("oprName"),
      trigger: "blur"
    }
  ],
  operatorId: [
    {
      required: true,
      validator: validate.abcNumber,
      name: i18n.t("operatorId"),
      trigger: "blur",
      len: 9
    }
  ],
  companyName: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("oper.companyName"),
      trigger: "blur"
    }
  ],
  signName: [
    { required: true, message: i18n.t("oper.signNamePl"), trigger: "blur" }
  ],
  contactsMail: [
    {
      required: true,
      validator: validate.emailRegular,
      trigger: "blur"
    }
  ],
  contactPerson: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("oper.contactPerson"),
      trigger: "blur",
      max: 50
    }
  ],

  oprSystemName: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("oper.oprSystemName"),
      trigger: "blur"
    }
  ],
  // qrCodeAddr: [
  //   {
  //     required: true,
  //     validator: validate.name,
  //     name: "二维码前缀",
  //     trigger: "blur",
  //     max: 100
  //   }
  // ],
  appId: [
    {
      required: true,
      validator: validate.name,
      name: "ID",
      trigger: "blur",
      max: 100
    }
  ],
  weChatName: [
    {
      required: true,
      validator: validate.name,
      // name: "名称",
      trigger: "blur"
    }
  ],
  appSecret: [
    {
      required: true,
      validator: validate.name,
      name: "secret",
      trigger: "blur",
      max: 200
    }
  ],
  domainName: [
    {
      required: true,
      validator: validate.name,
      name: "secret",
      trigger: "blur",
      max: 200
    }
  ],
  mchId: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operWeChat.mchId"),
      trigger: "blur",
      max: 100
    }
  ],
  mchName: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operWeChat.mchName"),
      trigger: "blur",
      max: 30
    }
  ],
  // mchShortName: [
  //   {
  //     required: true,
  //     validator: validate.name,
  //     name: "商户简称",
  //     trigger: "blur"
  //   }
  // ],
  mchBindPhoneNo: [
    {
      required: true,
      validator: validate.tel,
      trigger: "blur"
    }
  ],
  primevalId: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operWeChat.primevalId"),
      trigger: "blur",
      max: 100
    }
  ],
  mchKey: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operWeChat.mchKey"),
      trigger: "blur",
      max: 200
    }
  ],
  // oprSystemLogoFilePath: [
  //   {
  //     required: true,
  //     message: i18n.t("oper.oprSystemLogoFilePathPl"),
  //     trigger: "change"
  //   }
  // ],
  qrCodeFilePath: [
    {
      required: true,
      message: i18n.t("oper.qrCodeFilePathPl"),
      trigger: "change"
    }
  ],
  mchCertFilePath: [
    {
      required: true,
      message: i18n.t("oper.mchCertFilePathPl"),
      trigger: "change"
    }
  ],
  weChatLogo: [
    { required: true, message: i18n.t("oper.logoPl"), trigger: "change" }
  ],

  activeTime: [
    {
      required: true,
      message: i18n.t("oper.activeTimePl"),
      trigger: "change",
      type: "date"
    }
  ],
  templateId: [
    {
      required: true,
      message: i18n.t("oper.please"),
      trigger: "blur"
    }
  ],
  logo: [{ required: true, message: i18n.t("oper.logoPl"), trigger: "change" }],
  qrCode: [
    { required: true, message: i18n.t("oper.logoPl"), trigger: "change" }
  ],
  zfbName: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operPay.zfbName"),
      trigger: "blur"
    }
  ],
  privateKey: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operPay.privateKey"),
      trigger: "blur",
      max: 2000
    }
  ],
  alipayPublicKey: [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operPay.alipayPublicKey"),
      trigger: "blur",
      max: 2000
    }
  ],
  // notifyUrl: [
  //   {
  //     required: true,
  //     validator: validate.name,
  //     name: "支付异步通知接口",
  //     trigger: "blur",
  //     max: 1000
  //   }
  // ],
  serviceTel: [
    {
      required: true,
      validator: validate.tel,
      trigger: "blur"
    }
  ],
  wxPayMethod: [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "wxMchConfigInfo.appId": [
    {
      required: true,
      validator: validate.name,
      name: "ID",
      trigger: "blur",
      max: 100
    }
  ],
  "wxMchConfigInfo.appSecret": [
    {
      required: true,
      validator: validate.name,
      name: "secret",
      trigger: "blur",
      max: 200
    }
  ],
  "wxMchConfigInfo.primevalId": [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operWeChat.primevalId"),
      trigger: "blur",
      max: 100
    }
  ],
  "wxMchConfigInfo.weChatName": [
    {
      required: true,
      validator: validate.name,
      // name: "名称",
      trigger: "blur"
    }
  ],
  "wxMchConfigInfo.weChatLogo": [
    { required: true, message: i18n.t("oper.logoPl"), trigger: "change" }
  ],
  "wxMchConfigInfo.qrCodeFilePath": [
    {
      required: true,
      message: i18n.t("oper.qrCodeFilePathPl"),
      trigger: "change"
    }
  ],
  "wxMchConfigInfo.mchName": [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operWeChat.mchName"),
      trigger: "blur",
      max: 30
    }
  ],
  "wxMchConfigInfo.mchKey": [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operWeChat.mchKey"),
      trigger: "blur",
      max: 200
    }
  ],
  "wxMchConfigInfo.mchId": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "wxMchConfigInfo.mchCertFilePath": [
    {
      required: true,
      message: i18n.t("oper.mchCertFilePathPl"),
      trigger: "change"
    }
  ],
  "xlMchConfigInfo.mchId": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "xlMchConfigInfo.mchCertName": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "xlMchConfigInfo.mchCert": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "xlMchConfigInfo.mchCertPwd": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "xlMiniConfigInfo.mchId": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "xlMiniConfigInfo.mchCertName": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "xlMiniConfigInfo.mchCert": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "xlMiniConfigInfo.mchCertPwd": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "ccbMchConfigInfo.mchName": [
    {
      required: true,
      validator: validate.name,
      name: i18n.t("operWeChat.mchName"),
      trigger: "blur",
      max: 30
    }
  ],
  "ccbMchConfigInfo.mchId": [
    {
      required: true,
      validator: validate.abcNumber,
      name: i18n.t("operWeChat.mchId"),
      trigger: "blur"
    }
  ],
  "ccbMchConfigInfo.mchKey": [
    {
      required: true,
      message: i18n.t("regular.please"),
      max: 500,
      trigger: "blur"
    }
  ],
  "ccbMchConfigInfo.mchPosid": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "ccbMchConfigInfo.mchBranchid": [
    {
      // required: true,
      // message: i18n.t("regular.please"),
      // trigger: "blur",
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "ccbMchConfigInfo.mchTxCode": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "ccbMchConfigInfo.mchUserId": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "ccbMchConfigInfo.mchPassword": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "ccbMchConfigInfo.ipAddr": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ],
  "ccbMchConfigInfo.port": [
    {
      required: true,
      message: i18n.t("regular.please"),
      trigger: "blur"
    }
  ]
};

export default ruleInline;
